import { BIBME, EASYBIB } from '@src/state/site/types'
import media, { PHONE_DOUBLE_ZOOM } from '@src/styled/media'
import { Link, LinkProps } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { HamburgerMenu } from '../LeftSide'
import * as Types from './types'

export const AccountMenuItem = styled.li`
  line-height: 45px;
  border-bottom: 1px solid ${props => props.theme.colors.grey};
  padding-left: ${props => props.theme.spacing.md3};
  cursor: pointer;
`

const accountMenuItemCss = css`
  text-decoration: none;
  line-height: 45px;
  color: ${({ theme }) => theme.colors.grey};
`
export const AccountMenuItemLink = styled.a<{ href?: string }>`
  ${accountMenuItemCss}
`

export const AccountMenuItemRouterLink = styled(Link)<LinkProps>`
  text-decoration: none;
  line-height: 45px;
  color: ${({ theme }) => theme.colors.grey};
`

export const AccountDropDown = styled.div<Types.AccountMenuProps>`
  top: 0;
  display: ${props => (props.site === EASYBIB ? 'none' : 'flex')};
  @media only screen and (min-width: 760px) {
    display: none;
  }
  flex-direction: column;
  margin-right: ${props => props.theme.spacing.md3};
`

export const AccountHamburger = styled(HamburgerMenu)`
  cursor: pointer;
`

export const AccountLinks = styled.div<Types.AccountMenuProps>`
  padding-right: 43px;
  display: flex;
  ${({ theme }) => media[PHONE_DOUBLE_ZOOM]`
    flex-direction: column;
    > a, > ${AccountMenuItem} {
      margin: ${theme.spacing.xs} 0;
    }
  `}
`

export const Menu = styled.ul<Types.AccountMenuProps>`
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 100;
  border: 1px solid ${props => props.theme.colors.grey};
  top: 40px;
  right: 0px;
  width: 100vw;
  background-color: ${props =>
    props.site === BIBME
      ? props.theme.colors.greyXlight
      : props.theme.colors.mustardLight};
`



// WEBPACK FOOTER //
// ./src/components/Header/AccountMenu/styles.ts